module.exports = __webpack_public_path__ + "media/assets/img/flags/sv-SE-7feabb1881584be6eebec51635c660a3.png";